import { http } from './config/config-get-weather-forecasts'
export default {
  getWeatherForecast: async (ibge) => {
    return http.get(`/previsao/${ibge}`)
  },
}
